<template>
  <div :class="style.loader">
    <span />
  </div>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./LoaderTextButton.module.scss";
export default defineComponent({
  data() {
    return {
      style
    };
  }
});
</script>
